//-------------------------------------------------------------------------
// 
// !!! Do not edit this file manually !!!
// 
// This file was autogenerated from the Frontier primitives variables
// 
// Run "npm run build-primitives" to rebuild it
// 
//-------------------------------------------------------------------------

export type IThemeProperty<Type> = Type | Type[] | {
	_?: Type;
	sm?: Type;
	md?: Type;
	lg?: Type;
	xl?: Type;
};

export interface ITheme {
	colors: {
		white: string;
		whiteFade: string[];
		black: string;
		blackFade: string[];
		gray: string[];
		primary: string[];
		secondary: string[];
		alternate: string[];
		blue: string[];
		green: string[];
		orange: string[];
		pink: string[];
		purple: string[];
		red: string[];
		yellow: string[];
		body: string;
		text: string;
		muted: string;
		anchor: string;
		border: string;
		outline: string;
		code: string;
		[name: string]: string | string[];
	};
	breakpoints: string[];
	sizes: {
		sm: string;
		md: string;
		lg: string;
		xl: string;
		col1: string;
		col2: string;
		col3: string;
		col4: string;
		col5: string;
		col6: string;
		col7: string;
		col8: string;
		col9: string;
		col10: string;
		col11: string;
		col12: string;
		[name: string]: string;
	};
	space: string[];
	fonts: {
		normal: string;
		mono: string;
		display: string;
		[name: string]: string;
	};
	fontSizes: string[];
	fontNamedSizes: {
		small: Array<string | null>;
		normal: Array<string | null>;
		medium: Array<string | null>;
		large: Array<string | null>;
		f1: Array<string | null>;
		f2: Array<string | null>;
		f3: Array<string | null>;
		f4: Array<string | null>;
		f5: Array<string | null>;
		f6: Array<string | null>;
		d1: Array<string | null>;
		d2: Array<string | null>;
		d3: Array<string | null>;
		d4: Array<string | null>;
		[name: string]: Array<string | null>;
	};
	fontWeights: {
		normal: number;
		bold: number;
		semibold: number;
		light: number;
		[name: string]: number;
	};
	lineHeights: {
		default: number;
		condensed: number;
		single: number;
		[name: string]: number;
	};
	radii: string[];
	shadows: {
		small: string;
		default: string;
		medium: string;
		large: string;
		xlarge: string;
		[name: string]: string;
	};
	borders: string[];
	zIndices: {
		body: number;
		dropdown: number;
		sticky: number;
		fixed: number;
		modalbg: number;
		modal: number;
		popover: number;
		tooltip: number;
		sidebarbg: number;
		sidebar: number;
		[name: string]: number;
	};
}


const theme: ITheme = {
	colors: {
		white: "#ffffff",
		whiteFade: ["rgba(255,255,255,0.85)","rgba(255,255,255,0.70)","rgba(255,255,255,0.50)","rgba(255,255,255,0.30)","rgba(255,255,255,0.15)"],
		black: "#1b1f23",
		blackFade: ["rgba(27,31,35,0.85)","rgba(27,31,35,0.70)","rgba(27,31,35,0.50)","rgba(27,31,35,0.30)","rgba(27,31,35,0.15)"],
		gray: ["#fbfcfd","#f6f8fa","#e1e4e8","#d1d5da","#959da5","#6a737d","#586069","#444d56","#2f363d","#24292e"],
		primary: ["#F6F8FF","#D0DCFF","#A9BCFF","#869AFF","#6978FF","#5256FF","#4A40FF","#382EDC","#2B22B6","#20198F"],
		secondary: ["#FFF5FC","#FFB8FE","#FF7FFF","#FF4CFF","#EE21FF","#CE00F7","#C400DA","#B000B8","#920391","#6B0764"],
		alternate: ["#F5F1F7","#DACEE8","#C8BAE3","#B2A5D9","#9890CA","#7D7AB5","#636698","#484F73","#2C3348","#050305"],
		blue: ["#E4F0FF","#8FBFF5","#589DEE","#2A7DE4","#095FD7","#004CC7","#003BBC","#0028AD","#00179B","#000987"],
		green: ["#E4F6EC","#B3E3C9","#88DDB1","#64D39D","#49C58C","#36B37E","#209D69","#00875A","#118154","#006644"],
		orange: ["#FFF8F2","#FFEBDA","#FFD1AC","#FFAB70","#FB8532","#F66A0A","#E36209","#D15704","#C24E00","#A04100"],
		pink: ["#FFEEF8","#FEDBF0","#F9B3DD","#F692CE","#EC6CB9","#EA4AAA","#D03592","#B93A86","#99306F","#6D224F"],
		purple: ["#F5F0FF","#E6DCFD","#D1BCF9","#B392F0","#8A63D2","#6F42C1","#5A32A3","#4C2889","#3A1D6E","#29134E"],
		red: ["#FDEEF0","#F9BDC5","#F58CA1","#F37C8C","#F05B70","#EF4B62","#D4455A","#B43E50","#AE3748","#6D232D"],
		yellow: ["#FEF8F0","#FCE5C4","#FBDFB5","#FAD298","#F9C57B","#F8B95E","#EBAA52","#DB9B48","#CB984D","#9E763C"],
		body: "#ffffff",
		text: "#2f363d",
		muted: "#6a737d",
		anchor: "#004CC7",
		border: "#e1e4e8",
		outline: "rgba(0,76,199,0.3)",
		code: "#EA4AAA",
	},
	breakpoints: ["544px","768px","1012px","1280px"],
	sizes: {
		sm: "544px",
		md: "768px",
		lg: "1012px",
		xl: "1280px",
		col1: "8.3333%",
		col2: "16.6667%",
		col3: "25.0000%",
		col4: "33.3333%",
		col5: "41.6667%",
		col6: "50.0000%",
		col7: "58.3333%",
		col8: "66.6667%",
		col9: "75.0000%",
		col10: "83.3333%",
		col11: "91.6667%",
		col12: "100%",
	},
	space: ["0","4px","8px","16px","24px","32px","40px","48px","56px","64px","72px","80px","88px","96px"],
	fonts: {
		normal: "-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji'",
		mono: "SFMono-Regular,Consolas,'Liberation Mono',Menlo,monospace",
		display: "Quicksand,-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji'",
	},
	fontSizes: ["12px","14px","16px","18px","20px","22px","24px","26px","30px","32px","38px","45px","63px"],
	fontNamedSizes: {
		small: ["14px"],
		normal: ["16px"],
		medium: ["18px"],
		large: ["20px"],
		f1: ["24px",null,"32px"],
		f2: ["20px",null,"22px"],
		f3: ["14px",null,"18px"],
		f4: ["16px"],
		f5: ["14px"],
		f6: ["12px"],
		d1: ["32px",null,"63px"],
		d2: ["26px",null,"45px"],
		d3: ["24px",null,"38px"],
		d4: ["22px",null,"30px"],
	},
	fontWeights: {
		normal: 400,
		bold: 600,
		semibold: 500,
		light: 300,
	},
	lineHeights: {
		default: 1.5,
		condensed: 1.3,
		single: 1,
	},
	radii: ["0","2px","4px","6px","12px"],
	shadows: {
		small: "0 4px 8px rgba(208, 220, 255, 0.25)",
		default: "0 1px 8px rgba(27, 31, 35, 0.1)",
		medium: "0 10px 20px rgba(27, 31, 35, 0.15)",
		large: "0 25px 40px rgba(27, 31, 35, 0.15)",
		xlarge: "0 40px 40px rgba(72, 31, 35, 0.1)",
	},
	borders: ["0", "1px solid"],
	zIndices: {
		body: 100,
		dropdown: 1000,
		sticky: 1020,
		fixed: 1030,
		modalbg: 1040,
		modal: 1050,
		popover: 1060,
		tooltip: 1070,
		sidebarbg: 1080,
		sidebar: 1090,
	},
};

(theme.breakpoints as any).sm = theme.breakpoints[0];
(theme.breakpoints as any).md = theme.breakpoints[1];
(theme.breakpoints as any).lg = theme.breakpoints[2];
(theme.breakpoints as any).xl = theme.breakpoints[3];

export { theme };
